export default class data {
  constructor(companyCode) {
    this.company_code = companyCode;
  }
}
